import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { SharedLibsModule } from 'app/shared/shared-libs.module';
import { RolePipe } from './pipes/role.pipe';
import { DomainInterceptor } from 'app/blocks/interceptor/domain.interceptor';
import { ErrorHandlerInterceptor } from 'app/blocks/interceptor/error-handler.interceptor';



@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SharedLibsModule
  ],
  declarations: [
    RolePipe
  ],
  exports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SharedLibsModule,
    RolePipe
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: DomainInterceptor,
    multi: true,
  }, {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorHandlerInterceptor,
    multi: true,
  }]
})
export class SharedCommonModule {
}
